import React, { PropTypes, Component } from 'react';
import ColorRoundExclamation from '../../Svg/ColorRoundExclamation';
import ColorRoundCheckmark from '../../Svg/ColorRoundCheckmark';
import classes from '../shared.scss';
import classnames from 'classnames';

const validationIcon = (valid) => {
  const wrapperClasses = classnames({
    [classes['validation-wrapper']]: true,
    [classes['validation-valid']]: valid === true,
    [classes['validation-invalid']]: valid === false,
  });
  return (<span className={ wrapperClasses }>
    <ColorRoundCheckmark className={ classes['valid-icon'] } />
    <ColorRoundExclamation className={ classes['invalid-icon'] } />
  </span>);
};

const ValidationIcon = (props) => {
  return validationIcon(props.valid)
}

ValidationIcon.propTypes = {
  valid: PropTypes.bool,
};

export default ValidationIcon;



/** WEBPACK FOOTER **
 ** ./shared-components/FormFields/ValidationIcon/index.js
 **/